import { FC, PropsWithChildren } from "react";
import Settings from "@components/shared/modals/Settings";
import { createModalHelpers } from "@stores/unified-modal.store";
import WalletSelect from "@/components/shared/modals/Profile/Select";

const Content: FC<PropsWithChildren> = ({ children }) => {
    const modalHelpers = createModalHelpers();
    const { openModal, toggleModal } = modalHelpers;
    return (
        <section className={"blobs flex gap-8 flex-col w-full"}>
            <WalletSelect isVisible={modalHelpers.select} setIsVisible={() => toggleModal("select")} />
            <Settings />
            <div
                className={
                    "grid grid-cols-1 md:grid-cols-3 md:grid-rows-1 grid-rows-2 md:gap-x-4 gap-x-0 gap-4 h-fit w-full min-w-full"
                }
            >
                {children}
            </div>
        </section>
    );
};

export default Content;
